import { activeSiteCountry } from "@config/site/site-config";

// This file contains the list of restricted countries that shouldn't pull all the data for the store locator.
// For business reasons, for US and CA store locator only will show stores for those countries specifically. Otherwise, it will show all the stores.
const RestrictedEUCountries = [
    "CZ",
    "DK",
    "FI",
    "EE",
    "HU",
    "FR",
    "DE",
    "SE",
    "NL",
    "LT",
    "LV",
    "CH",
    "PL",
    "BE",
    "AT",
    "NO",
    "SK",
    "IE",
    "SI",
    "HR",
    "PT",
    "ES",
];

const restrictedCountries = [
    "US",
    "CA",
    "SG",
    "AU",
    "JP",
    "MY",
    "KR",
    "IN",
    ...RestrictedEUCountries,
];

const shouldRestrictSearchToMarket = (country: string) => {
    return restrictedCountries.includes(country);
};

export const RESTRICT_SEARCH_TO_CURRENT_MARKET = shouldRestrictSearchToMarket(activeSiteCountry);
